import {useApi} from '../../classes/appApi'
import EqxFormModal, {EqxFormModalProps} from '../../shared/components/EqxFormModal'

//insert api into form props automatically
export interface FormModalProps extends Omit<EqxFormModalProps, 'api'> {}
const FormModal = (props: FormModalProps) => {
    const api = useApi()
    return <EqxFormModal {...props} api={api} />
}
export {FormModal as default}
